document.addEventListener("DOMContentLoaded", function () {
  let nextPage = 2;
  let isLoading = false;
  let finished = false;

  function initInfiniteScroll() {
    const productGrid = document.querySelector("#product-grid");

    if (!productGrid) {
      return;
    }

    // Prevent creating multiple sentinels
    if (document.querySelector("#infinite-scroll-sentinel")) {
      return;
    }

    // Create loading area
    const sentinel = document.createElement("div");
    sentinel.id = "infinite-scroll-sentinel";
    sentinel.innerHTML = `
      <div class="infinite-scroll-loading" style="
        text-align:center;
        padding:30px 0;
        display:none;
      ">
        Loading more products...
      </div>
    `;

    productGrid.parentElement.appendChild(sentinel);

    const loadingText = sentinel.querySelector(".infinite-scroll-loading");

    async function loadNextPage() {
      if (isLoading || finished) {
        return;
      }

      isLoading = true;
      loadingText.style.display = "block";

      try {
        // Keep current collection URL + filters + sorting
        const url = new URL(window.location.href);

        url.searchParams.set("page", nextPage);

        const response = await fetch(url.toString());

        if (!response.ok) {
          throw new Error("Failed to load page " + nextPage);
        }

        const html = await response.text();

        const parser = new DOMParser();

        const doc = parser.parseFromString(html, "text/html");

        const nextGrid = doc.querySelector("#product-grid");

        if (!nextGrid) {
          finished = true;
          return;
        }

        const products = Array.from(
          nextGrid.querySelectorAll(":scope > li")
        );

        console.log(
          "Infinite Scroll - Page:",
          nextPage,
          "Products:",
          products.length
        );

        // No products = collection finished
        if (products.length === 0) {
          finished = true;
          return;
        }

        // Append products
        products.forEach(function (product) {
          productGrid.appendChild(product);
        });

        // Move to next page
        nextPage++;

      } catch (error) {
        console.error("Infinite Scroll Error:", error);
      } finally {
        isLoading = false;
        loadingText.style.display = "none";
      }
    }

    // Detect when user reaches bottom
    const observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) {
          loadNextPage();
        }
      },
      {
        rootMargin: "1000px 0px"
      }
    );

    observer.observe(sentinel);

    console.log("✅ Infinite Scroll initialized");
  }

  initInfiniteScroll();
});